var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47552 10.876C8.37917 10.8724 8.28767 10.8301 8.2195 10.7577C8.15133 10.6854 8.11155 10.5882 8.10816 10.486V8.68051C8.11176 7.81345 8.43874 6.98326 9.01755 6.37151C9.59635 5.75976 10.3799 5.41633 11.1966 5.41634H18.7068C19.5163 5.42015 20.2915 5.76423 20.8626 6.37327C21.4338 6.98232 21.7544 7.80673 21.7544 8.66614V10.4716C21.751 10.5739 21.7113 10.6709 21.6431 10.7433C21.5749 10.8156 21.4834 10.8579 21.3871 10.8615L8.47552 10.876ZM25.3735 8.33387V5.64739C25.3681 5.18457 25.277 4.72737 25.1052 4.30195C24.9334 3.87653 24.6844 3.49123 24.3723 3.16799C24.0603 2.84475 23.6913 2.58997 23.2865 2.41813C22.8816 2.24629 22.4489 2.16081 22.0129 2.16653H19.8497C19.579 2.16653 19.3195 2.05241 19.1281 1.84926C18.9368 1.64611 18.8293 1.37057 18.8293 1.08327C18.8293 0.795967 18.9368 0.520427 19.1281 0.317275C19.3195 0.114124 19.579 2.82579e-07 19.8497 2.82579e-07H22.0129C23.4353 -0.000381986 24.8013 0.590361 25.8185 1.64588C26.8356 2.7014 27.4231 4.13777 27.4551 5.64739V8.33387C27.4551 8.625 27.3462 8.90423 27.1523 9.11009C26.9583 9.31595 26.6953 9.4316 26.4211 9.4316C26.1468 9.4316 25.8838 9.31595 25.6899 9.11009C25.496 8.90423 25.3871 8.625 25.3871 8.33387H25.3735ZM2.46191 8.33387V5.63294C2.49742 4.12584 3.08642 2.6932 4.1032 1.64077C5.11998 0.588335 6.484 -0.000470904 7.90409 2.82579e-07H10.1082C10.3788 2.82579e-07 10.6383 0.114124 10.8297 0.317275C11.0211 0.520427 11.1286 0.795967 11.1286 1.08327C11.1286 1.37057 11.0211 1.64611 10.8297 1.84926C10.6383 2.05241 10.3788 2.16653 10.1082 2.16653H7.87687C7.44335 2.16081 7.01304 2.24605 6.61062 2.41734C6.20821 2.58863 5.84161 2.84256 5.5319 3.16464C5.22219 3.48672 4.97544 3.87061 4.80583 4.29419C4.63622 4.71777 4.54709 5.17269 4.54354 5.63294V8.33387C4.51428 8.60515 4.39203 8.85551 4.20009 9.03727C4.00815 9.21904 3.75994 9.31955 3.50273 9.31955C3.24552 9.31955 2.99729 9.21904 2.80535 9.03727C2.61341 8.85551 2.49118 8.60515 2.46191 8.33387Z",
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8844 13.0569H1.02041C0.749779 13.0569 0.490249 13.1711 0.298885 13.3742C0.107522 13.5774 0 13.8529 0 14.1402C0 14.4275 0.107522 14.7031 0.298885 14.9062C0.490249 15.1094 0.749779 15.2235 1.02041 15.2235H2.4626V20.3654C2.4981 21.8725 3.0871 23.3051 4.10389 24.3576C5.12067 25.41 6.48469 25.9989 7.90478 25.9984H10.1225C10.2562 26.0062 10.3901 25.9852 10.5161 25.9366C10.642 25.888 10.7574 25.8128 10.8553 25.7157C10.9532 25.6185 11.0315 25.5014 11.0856 25.3713C11.1397 25.2411 11.1684 25.1007 11.1701 24.9584C11.1774 24.6735 11.0787 24.397 10.8954 24.1888C10.712 23.9806 10.4587 23.8575 10.1905 23.8462H7.87756C7.44339 23.8501 7.01276 23.7631 6.61027 23.5902C6.20778 23.4174 5.84131 23.162 5.53178 22.8388C5.22225 22.5156 4.97571 22.1307 4.80627 21.7063C4.63682 21.282 4.54779 20.8263 4.54423 20.3654V15.2235H8.14967V16.6678C8.15326 17.5349 8.48024 18.3652 9.05905 18.9769C9.63785 19.5887 10.4214 19.9321 11.2381 19.9321H18.7483C19.1532 19.934 19.5545 19.8509 19.9292 19.6877C20.3038 19.5245 20.6444 19.2845 20.9313 18.9812C21.2183 18.6778 21.446 18.3173 21.6014 17.9204C21.7568 17.5234 21.8367 17.0977 21.8367 16.6678V15.2235H25.4014V20.3654C25.3978 20.8275 25.3083 21.2844 25.138 21.7097C24.9677 22.135 24.72 22.5205 24.409 22.8439C24.098 23.1673 23.73 23.4224 23.3259 23.5944C22.9218 23.7664 22.4897 23.852 22.0544 23.8462H19.8504C19.6018 23.8769 19.3724 24.0035 19.206 24.2019C19.0395 24.4003 18.9476 24.6567 18.9476 24.9224C18.9476 25.188 19.0395 25.4444 19.206 25.6428C19.3724 25.8412 19.6018 25.9678 19.8504 25.9984H22.0816C23.5017 25.9989 24.8657 25.41 25.8825 24.3576C26.8993 23.3051 27.4883 21.8725 27.5238 20.3654V15.2235H28.966C29.2379 15.2235 29.4988 15.1098 29.6924 14.9071C29.8859 14.7043 29.9964 14.4288 30 14.1402C29.9964 13.8516 29.8859 13.5761 29.6924 13.3733C29.4988 13.1706 29.2379 13.0569 28.966 13.0569",
    fill: "url(#paint1_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i",
    x: 0,
    y: 13.0569,
    width: 30,
    height: 14.943,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 14.9585,
    y1: 10.876,
    x2: 14.9585,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#A0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DC1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: -2.25706,
    y1: -0.144945,
    x2: 36.171,
    y2: 4.44647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.b3becdc03366d5d79efa1d2da6e49b83.svg";
export { ForwardRef as ReactComponent };